import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initNativeBridge } from "@/utils/capacitor";
import { initTizenBridge } from "@/utils/tizen";

// Initialize platform bridges (no-ops when not on that platform)
initNativeBridge();
initTizenBridge();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
